import {AjaxFactory, HttpMethod} from '../../_libs/redux-observable-list';
import {getSuccessOnlyResponseStatus} from '../../core-utilities/redux-request/utils';
import {ReduxRequest} from '../../core-utilities/redux-request';
import {API_URL} from '../constants';
import {BASE_REDUX_LIST_OPTIONS} from './index';


/**
 * @param {Object} config
 * @param {String} config.prefix
 * @param {Function} config.getState
 * @param {String} config.path
 * @param {Logger} config.logger
 * @return {ReduxRequest}
 */
export function buildCreateRequest(config) {
  const {
    prefix,
    getState,
    path,
    logger,
  } = config;

  return new ReduxRequest({
    prefix,
    getState,
    requestFactory: buildAjaxFactory({
      ...BASE_REDUX_LIST_OPTIONS,
    }),
    buildRequest: (state, payload) => payload,

    getResponseStatus: getSuccessOnlyResponseStatus,
    autoReset: 3500,
    logger,
  });

  /**
   * @param options
   * @return {AjaxFactory}
   */
  function buildAjaxFactory(options) {
    return new AjaxFactory({
      crossDomain: options.crossDomain,
      method: HttpMethod.POST,
      useBody: true,
      url: `${options.baseApiUrl}/${path}`,
      getToken: options.getToken,
      responseType: request => 'json',
    });
  }
}

/** @typedef {Object} UpdateRequestSendRequestPayload
 * @property {Object} data
 * @property {String} data.id
 * @property {Object} body
 */

/**
 * @param {Object} config
 * @param {String} config.prefix
 * @param {Function} config.getState
 * @param {String} config.path
 * @param {Logger} config.logger
 * @return {ReduxRequest}
 */
export function buildUpdateRequest(config) {
  const {
    prefix,
    getState,
    path,
    logger,
  } = config;

  return new ReduxRequest({
    prefix,
    getState,
    requestFactory: buildAjaxFactory({
      ...BASE_REDUX_LIST_OPTIONS,
    }),
    buildRequest: (state, payload) => payload,

    getResponseStatus: getSuccessOnlyResponseStatus,
    autoReset: 3500,
    logger,
  });

  /**
   * @param options
   * @return {AjaxFactory}
   */
  function buildAjaxFactory(options) {
    return new AjaxFactory({
      crossDomain: options.crossDomain,
      method: HttpMethod.PATCH,
      useBody: true,
      url: payload => {
        return `${options.baseApiUrl}/${path}/${payload.data.id}`;
      },
      getToken: options.getToken,
      responseType: request => 'json',
      getBody: payload => payload.body,
      serializeBody: payload => JSON.stringify(payload.body),
    });
  }
}

/**
 * Add the on-error action to:
 * src/js/system/epics/onDeleteEpic.js
 *
 * @param {Object} config
 * @param {String} config.prefix
 * @param {Function} config.getState
 * @param {String} config.path
 * @param {Logger} config.logger
 * @return {ReduxRequest}
 */
export function buildDeleteRequest(config) {
  const {
    prefix,
    getState,
    path,
    logger,
  } = config;

  return new ReduxRequest({
    prefix,
    getState,
    requestFactory: buildAjaxFactory({
      ...BASE_REDUX_LIST_OPTIONS,
    }),
    buildRequest: (state, payload) => payload,

    getResponseStatus: getSuccessOnlyResponseStatus,
    autoReset: 3500,
    logger,
  });

  /**
   * @param options
   * @return {AjaxFactory}
   */
  function buildAjaxFactory(options) {
    return new AjaxFactory({
      crossDomain: options.crossDomain,
      method: HttpMethod.DELETE,
      useBody: false,
      url: payload => `${options.baseApiUrl}/${path}/${payload.id}`,
      getToken: options.getToken,
      responseType: request => 'json',
    });
  }
}




// WEBPACK FOOTER //
// ./src/js/config/redux-list/requests.js